/* eslint-disable camelcase */
import React from 'react';
import { useDispatch } from 'react-redux';
import { errorMessage, removeClientAddressAsync } from '../../../actions/ClientData';
import { TAddress } from '../../../types';
import { capitalizeFirstLetter } from '../../../utils';

const searchType = {
    POSTCODE: 'postcode',
    CLIENT: 'client',
};

export type TAddressSelector = {
    addressList: TAddress[];
    searchByPostcode?: boolean;
    itemSelected: (e: React.FormEvent<HTMLElement>) => void;
};

export function AddressSelector({
    addressList,
    searchByPostcode,
    itemSelected,
}: TAddressSelector) {
    const dispatch = useDispatch();

    const removeAddress = (e: React.FormEvent<HTMLElement>) => {
        const value = addressList[(e.target as any).value];
        dispatch(removeClientAddressAsync(value));
        dispatch(errorMessage('postcode', null));
        e.stopPropagation();
    };

    return (
        <ul className="address-list">
            {addressList?.map((address: TAddress, i: number) => (
                // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                <li
                    // eslint-disable-next-line react/no-array-index-key
                    key={`address${i}`}
                    value={i}
                    data-type={
                        searchByPostcode
                            ? searchType.POSTCODE
                            : searchType.CLIENT
                    }
                    onClick={itemSelected}
                >
                    <div className="address-info">
                        <p>{address.address1}</p>
                        <p>{address.address2}</p>
                        <p>
                            {address?.city &&
                                capitalizeFirstLetter(address.city)}
                        </p>
                    </div>

                    {searchByPostcode ?? (
                        <button onClick={removeAddress} value={i} type="submit">
                            Remove
                        </button>
                    )}
                </li>
            ))}
        </ul>
    );
}
